import {
  CustomFieldProps,
  DynamicField,
  DynamicForm,
  FieldVariant,
  MultiSelectFieldProps,
  SelectOption,
} from '@/components/form-builder/form-builder.types';
import { MultiFormAccordionComponent } from '@/components/multi-form-accordion/multi-form-accordion.component';
import { DacGeneralParamsRepository } from '@/store/dac-general-params-state/dac-general-params-state.repository';
import { ParamGeneralFieldFormComponent } from '../../param-general-field-form/param-general-field-form.component';

interface GetCreateDacGeneralParamsFormObjectProps {
  store: DacGeneralParamsRepository;
  dynaDocsModelOptions?: SelectOption[];
}

export const getCreateDacGeneralParamsFormObject = ({
  store,
  dynaDocsModelOptions,
}: GetCreateDacGeneralParamsFormObjectProps): DynamicForm => {
  const dynaDocsModelField: DynamicField<MultiSelectFieldProps> = {
    label: 'dacGeneralParams.form.dynaDocsModel',
    variant: FieldVariant.MULTISELECT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'dynaDocsModelIds'),
    props: {
      placeholder: 'dacGeneralParams.form.dynaDocsModelPlaceholder',
      options: dynaDocsModelOptions,
      value: store.getObservable('dynaDocsModelSelected'),
      onSelectChange: (values: SelectOption[]) => {
        store.setNested('createDto', 'dynaDocsModelIds', values.map(v => v.code as number));
        store.set('dynaDocsModelSelected', values);
        store.setNested('errors', 'dynaDocsModelIds', '');
      },
    },
  };

  const fieldsAccordion: DynamicField<CustomFieldProps> = {
    label: 'dacGeneralParams.field.title',
    variant: FieldVariant.CUSTOM,
    props: {
      component: MultiFormAccordionComponent,
      injectKeys: ['accordionObject'],
      accordionObject: {
        titles: ['dacGeneralParams.field.singular'],
        component: ParamGeneralFieldFormComponent,
        injectKeys: [],
      },
    },
  };

  return {
    title: 'dacGeneralParams.singular',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [{ fields: [dynaDocsModelField] }, { fields: [fieldsAccordion] }],
      },
    ],
  };
};
